import React from "react";
import { Sparkles } from "lucide-react";
import logoImg from "../assets/logo.png";

/**
 * 3D rotating medallion with two faces (logo / name).
 * Props:
 *  - size: "sm" | "md" | "lg"  (default "md")
 *  - lang: "he" | "ar"
 *  - showName: boolean — if false, the back face also shows the logo (used in tight UI spots)
 *  - withOrbit: boolean — show the dashed orbit ring + glow halo
 *  - withHalo: boolean — show the blurred multi-color halo behind
 */
export default function RotatingLogo({
    size = "md",
    lang = "he",
    showName = true,
    withOrbit = false,
    withHalo = false,
    className = "",
    testId,
}) {
    return (
        <div
            className={`medallion-scene medallion-${size} ${className}`}
            data-testid={testId || "rotating-logo"}
        >
            {withHalo && (
                <div className="absolute -inset-4 rounded-full bg-gradient-to-br from-[#D4761F] via-[#D4AF37] to-[#1A365D] opacity-60 blur-2xl animate-pulse" />
            )}
            {withOrbit && <span className="medallion-orbit" />}

            <div className="medallion-coin">
                {/* FRONT — logo */}
                <div className="medallion-face medallion-front">
                    <div className="medallion-rim">
                        <div className="medallion-inner">
                            <img
                                src={logoImg}
                                alt="Al-Ahliyya"
                                className="medallion-logo-img"
                            />
                        </div>
                    </div>
                </div>

                {/* BACK — name (or logo again if showName=false) */}
                <div className="medallion-face medallion-back">
                    <div className="medallion-rim">
                        <div className={`medallion-inner ${showName ? "medallion-name" : ""}`}>
                            {showName ? (
                                <>
                                    <div className="medallion-name-brand">
                                        {lang === "ar" ? "الأهلية" : "אל-אהלייה"}
                                    </div>
                                    <div className="medallion-name-ai">
                                        <Sparkles size={size === "lg" ? 10 : 8} /> AI
                                    </div>
                                </>
                            ) : (
                                <img
                                    src={logoImg}
                                    alt="Al-Ahliyya"
                                    className="medallion-logo-img"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
